var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPalette(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 21L10 21C11.3062 21 12.4174 20.1652 12.8293 19L18 19C18.5523 19 19 18.5523 19 18L19 14C19 13.4478 18.5523 13.0001 18.0001 13L13 18V15.1717L17.7047 10.467C18.0953 10.0765 18.0953 9.44329 17.7048 9.05277L14.9474 6.29534C14.5568 5.90481 13.9237 5.90481 13.5332 6.29533L13 6.82848V6C13 5.45079 12.8524 4.93605 12.5948 4.49328C13.7587 3.72823 15.338 3.85752 16.3616 4.88114L19.119 7.63856C20.1426 8.66215 20.2718 10.2414 19.5068 11.4053C20.3998 11.925 21 12.8924 21 14L21 18C21 19.6569 19.6569 21 18 21Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 5L6 5C5.44772 5 5 5.44772 5 6L5 18C5 18.5523 5.44772 19 6 19H10C10.5523 19 11 18.5523 11 18L11 6C11 5.44772 10.5523 5 10 5ZM6 3C4.34315 3 3 4.34315 3 6L3 18C3 19.6569 4.34315 21 6 21L10 21C11.6569 21 13 19.6569 13 18L13 6C13 4.34315 11.6569 3 10 3L6 3Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 16C9 16.5523 8.55228 17 8 17C7.44772 17 7 16.5523 7 16C7 15.4477 7.44772 15 8 15C8.55228 15 9 15.4477 9 16Z",
    fill: "url(#paint2_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 23.4291,
    y1: 26.625,
    x2: 9.68944,
    y2: -1.15269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0965F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31D8BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 23.4291,
    y1: 26.625,
    x2: 9.68944,
    y2: -1.15269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0965F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31D8BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 23.4291,
    y1: 26.625,
    x2: 9.68944,
    y2: -1.15269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0965F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31D8BF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalette);
export default __webpack_public_path__ + "static/media/palette.06766a47ccb83ed76f95f912d29b9eb9.svg";
export { ForwardRef as ReactComponent };